<template>
  <div>
    <v-container fluid>
      <button @click="openModal" class="openModal">Open modal</button>
    </v-container>

    <div id='Dialog__Overlay'
         class="v-overlay "
         style="z-index: 201;"
    >
    </div>
    <div id='Dialog__Content'
         tabindex="-1"
         data-v-fae5bece=""
         class="v-dialog__content"
         style="z-index: 1005;"
    >
      <div id="Dialog"
           class="v-dialog v-dialog--active"
      >
        <div class="v-card"
             data-v-fae5bece=""
        >
          <div data-v-fae5bece=""
               class="v-card__title headline lighten-2 v-card__title--primary"
          >
            <div>Primer modala za neku akciju</div>

            <button id='closeModalBtn'
                    @click='openModal'
                    class="v-btn v-btn--flat white"
            >
              <v-icon>close</v-icon>
            </button>
          </div> <!-- /.v-card__title -->

          <v-container fluid>
            <v-form ref="form" v-model="valid" lazy-validation>

              <v-layout row wrap align-center>
                <v-flex xs7 pa-2>
                  <v-select
                      :items="repromaterijali"
                      label="Repromaterijal"
                      persistent-hint
                      required
                  ></v-select>
                </v-flex>
                <v-flex xs2 pa-2 style="text-align: right;">
                  <a @click="addSection" class="addSection">DODAJ</a>
                </v-flex>
              </v-layout> <!-- /.row -->

              <div class="newSection hidden">
                <v-layout row wrap>
                  <v-flex xs12 pa-2>
                    <h3><b>Kreiranje novog repromaterijala</b></h3>
                  </v-flex>
                  <v-flex xs12 pa-2>
                    <v-text-field
                        label="Količina"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 pa-2>
                    <v-select
                        :items="units"
                        label="Naziv"
                        required
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 pa-2>
                    <v-textarea
                        name="input-5-1"
                        class="Description"
                        label="Opis"
                    ></v-textarea>
                  </v-flex>
                </v-layout> <!-- /.row -->
                <v-layout row wrap>
                  <button class="createButton">KREIRAJ</button>
                  <button class="saveButton">SAČUVAJ</button>
                </v-layout>
                <v-layout>
                  <v-data-table
      :headers="headers"
      :items="desserts"
      hide-actions
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.calories }}</td>
        <td>{{ props.item.fat }}</td>
        <td>{{ props.item.carbs }}</td>
        <td>{{ props.item.protein }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
                </v-layout>
              </div> <!-- /.newSection -->

              <v-layout row wrap>
                <v-flex xs4 pa-2>
                  <v-text-field
                      label="Količina"
                  ></v-text-field>
                </v-flex>

                <v-flex xs3 pa-2>
                  <v-select
                      :items="units"
                      label="litar"
                      required
                  ></v-select>
                </v-flex>
              </v-layout> <!-- /.row -->

              <v-layout row wrap>
                <v-layout row wrap>
                  <button class="saveButton--Green">SAČUVAJ</button>
                  <button class="cancelButton">odustani</button>
                </v-layout>
              </v-layout> <!-- /.row -->

            </v-form>
          </v-container>

        </div> <!-- /.v-card -->
      </div> <!-- /#Dialog -->
    </div> <!-- /#Dialog__Content -->
  </div> <!-- /.ModalUModalu -->
</template>
<script>
	export default {
		name: "ModalUModalu",
		dialog: false,
		data: () => ({
			valid: true,
			repromaterijali: ["Repromaterijal 1", "Repromaterijal 2", "Repromaterijal 3", "Repromaterijal 4"],
      units: ["Litar", "Decilitar", "Mililitar"],
      headers: [
      {
        text: "Dessert (100g serving)",
        align: "left",
        sortable: true,
        value: "name"
      },
      { text: "Calories", value: "calories" },
      { text: "Fat (g)", value: "fat" },
      { text: "Carbs (g)", value: "carbs" },
      { text: "Protein (g)", value: "protein" },
      { text: "Actions", value: "name", sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0
    }
    }),
    computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.initialize();
  },
		methods: {
			openModal(e) {
				e.preventDefault();

				const Dialog__Content = document.getElementById("Dialog__Content"),
					Dialog__Overlay = document.getElementById("Dialog__Overlay");

				function modalOpen() {
					Dialog__Content.style.display = "flex";
					Dialog__Content.classList += " v-dialog__content--active";
					Dialog__Overlay.style.display = "block";
					Dialog__Overlay.classList += " v-overlay--active";
				}

				function modalClose() {
					Dialog__Content.style.display = "none";
					Dialog__Content.classList.remove("v-dialog__content--active");
					Dialog__Overlay.style.display = "none";
					Dialog__Overlay.classList.remove("v-overlay--active");
				}

				if (e.target.className === 'openModal') {
					modalOpen();
				}

				if (e.target.id === "closeModalBtn") {
					modalClose();
				}


			},

			addSection() {
				let newSection = document.querySelector('.newSection');
				newSection.classList.toggle('hidden');
      },
      initialize() {
      this.desserts = [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0
        },
        {
          name: "Ice cream sandwich",
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3
        },
        {
          name: "Eclair",
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0
        },
        {
          name: "Cupcake",
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3
        },
        {
          name: "Gingerbread",
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9
        },
        {
          name: "Jelly bean",
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0
        },
        {
          name: "Lollipop",
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0
        },
        {
          name: "Honeycomb",
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5
        },
        {
          name: "Donut",
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9
        },
        {
          name: "KitKat",
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7
        }
      ];
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // this.dialog = true;

      //serverBus.$emit('applied', item);

      // // // console.log(item);
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
		}
	}
</script>
<style scoped lang='scss'>
  @import "./../assets/sass/parts/modalStyles";

  #Dialog {
    max-width: 500px;
  }

  .openModal {
    @include btn(#fff, #018389);
  }

  .addSection {
    @include btn(#018389, transparent)
  }

  .newSection {
    border-radius: 10px;
    background-color: #efefef;
    padding: 10px;
    &.hidden {
      display: none;
    }
  }

  .saveButton {
    @include btn(#fff, #7e7e7e);
    &--Green {
      @include btn(#fff, #018389);
      margin-right: 15px;
    }
  }

  .cancelButton {
    @include btn(#018389, transparent);
  }

  .createButton {
    @include btn(#7e7e7e, transparent);
    margin-right: 15px;

  }
</style>